import React from 'react';
import PropTypes from 'prop-types';
import Velocity from 'velocity-animate';

class SubNavigation extends React.PureComponent {
  // Settings are mostly here to manage all panel based transitions,
  // this includes wallpaper and transfer window move for full-panel.
  settings = {
    mobileHA: true,
    duration: 500, // .5s
    easing: [0.77, 0.0, 0.175, 1.0], // [cubic bezier]
  };

  componentDidMount() {
    if (!this.node) {
      return;
    }
    Velocity.hook(this.node, 'width', this.props.hasActiveChild ? 'auto' : 0);
  }

  slideIn() {
    if (!this.node) {
      return;
    }
    const currentValue = Velocity.hook(this.node, 'width');
    Velocity.hook(this.node, 'width', 'auto');

    const requiredValue = Velocity.hook(this.node, 'width');
    Velocity.hook(this.node, 'width', currentValue);

    Velocity(this.node, 'stop', true);
    Velocity(this.node, { width: requiredValue }, this.settings);
  }

  slideOut() {
    if (!this.node) {
      return;
    }
    Velocity(this.node, 'stop', true);
    Velocity(this.node, { width: '0px' }, this.settings);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.hasActiveChild && this.props.hasActiveChild) {
      this.slideIn();
    } else if (prevProps.hasActiveChild && !this.props.hasActiveChild) {
      this.slideOut();
    }
  }

  render() {
    const { children } = this.props;

    if (!React.Children.count(children)) {
      return null;
    }

    return (
      <ul ref={(node) => (this.node = node)} className="nav__subitems">
        {children}
      </ul>
    );
  }
}

SubNavigation.propTypes = {
  hasActiveChild: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

export default SubNavigation;
